import React, { useEffect, useState } from "react";
import { Box, Typography, TextField, Button, Grid, FormGroup, FormControl, Checkbox, FormControlLabel } from "@mui/material";
import { useApi } from "../api/useApi";
import { useAuth } from "../auth/AuthContext";
import { useNavigate } from "react-router-dom";

import { useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import PhoneInput from "react-country-phone-input";
import "react-country-phone-input/lib/style.css";
import { phonePatterns } from "./PhonePatterns";
const SuccessBanner = ({ open, message }) => {
  return (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ y: 50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 50, opacity: 0 }}
          transition={{ duration: 0.4, ease: "easeOut" }}
          style={{
            position: "fixed",
            bottom: "2rem",
            left: "35%",
            transform: "translateX(-50%)",
            display: "inline-flex",
            alignItems: "center",
            gap: "1rem",
            borderRadius: "1rem",
            border: "1px solid #00A300",
            background: "#016100",
            color: "#FFFFFF",
            // fontFamily: "Akkurat-Bold, sans-serif",
            fontSize: "0.9rem",
            fontWeight: 400,
            padding: "0.75rem 1.25rem",
            zIndex: 2000,
            boxShadow: "0 2px 10px rgba(0, 0, 0, 0.25)",
            textAlign: "center",
            maxWidth: "90%",
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M10 1.25C5.125 1.25 1.25 5.125 1.25 10C1.25 14.875 5.125 18.75 10 18.75C14.875 18.75 18.75 14.875 18.75 10C18.75 5.125 14.875 1.25 10 1.25ZM8.75 13.75L5.375 10.375L6.5 9.375L8.75 11.625L13.75 6.75L14.875 7.75L8.75 13.75Z"
              fill="#24A148"
            />
          </svg>

          <span>{message}</span>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
export default function Profile() {
  const { request } = useApi();

  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [successOpen, setSuccessOpen] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const email = user.email;
  const [errors, setErrors] = useState({});
  const [phoneError, setPhoneError] = useState("");
  const [phoneNumber, setPhoneNumber] = useState(
    location?.state?.phone ? location?.state?.phone : "",
  );
  const [profile, setProfile] = useState({
    userName: "",
    currentEmail: "",
    newEmail: "",
    phoneNumber: "",
    emailContact: false,
    phoneContact: false,
  });

  useEffect(() => {
    loadProfile();
  }, []);

  const handleCheckBoxChange = (e) => {
    const { name, checked } = e.target;
    setProfile((prev) => ({ ...prev, [name]: checked }));
  };

  const loadProfile = async () => {
    try {
      const response = await request({
        url: "/user/by-email",
        method: "GET",
        params: { email },
      });

      if (response?.length > 0) {
            setProfile({
              userName: response[0].userName || "",
              currentEmail: response[0].emailId || "",
              newEmail: response[0].emailId || "",
              phoneNumber: response[0].phoneNumber || "",
              emailContact:
                response[0].contactPreference?.includes("Email") || false,
              phoneContact:
                response[0].contactPreference?.includes("Phone") || false,
            });
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setProfile((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async () => {
    // const payload = {
    //   ...profile,
    // };
    console.log("Updated validate:", validate,phoneError,errors);
    if (!validate()) return;

    try {
      const payload = {
        ...profile,
        emailId: profile.newEmail,
        contactPreference:
          profile.emailContact && profile.phoneContact
            ? "Email,Phone"
            : profile.emailContact
            ? "Email"
            : profile.phoneContact
            ? "Phone"
            : "",
      };

      console.log("Updated profile:", payload);

      const response = await request({
        url: "user/update-contact-details",
        method: "POST",
        data: payload,
      });

      setSuccessMessage("Profile Update successfully");
      setSuccessOpen(true);
      setTimeout(() => setSuccessOpen(false), 3000);
      setTimeout(() => setSuccessMessage(""), 3000);
      if (payload?.currentEmail != payload?.emailId)
        setTimeout(() => logOut(), 3000);
    } catch (err) {
      console.log(err);
    }
  };
  const labelSx = {
    mb: 0.5,
    fontFamily: "Akkurat-Pro",
    fontSize: { xs: "0.8rem", lg: "0.75rem", xl: "0.9rem" },
    color: "#525252",
  };

  const errorSx = { color: "red", fontSize: "0.75rem" };
  const logOut = async () => {
    try {
      const res = await request({
        url: `user/logout?email=${profile.newEmail}`,
        method: "GET",
      });
      sessionStorage.removeItem("user");
      navigate("/");
    } catch (err) {
      console.error("Logout failed:", err);
    }
  };
  const handleCancel = async () => {
    navigate("/landing-page", { replace: true });
  };
  function validatePhone(phone, countryCode) {
    const digits = phone.replace(/\D/g, "");
    const entry = phonePatterns[countryCode?.toUpperCase()];
    if (!entry) return null;
    return entry.pattern.test(digits);
  }

  const handlePhoneChange = (value, countryData) => {
    setProfile((prev) => ({
      ...prev,
      phoneNumber: value,
    }));
    // setPhoneNumber(value ?? "");
    const iso = countryData?.countryCode?.toUpperCase();
    const dialCode = countryData?.dialCode ?? "";
    const localNumber = (value ?? "").replace(/\D/g, "").slice(dialCode.length);
    const valid = validatePhone(localNumber, iso);
    setPhoneError(
      valid === false
        ? `Invalid ${countryData?.name} number — ${phonePatterns[iso]?.hint}`
        : "",
    );
  };
  const validate = () => {
    const newErrors = {};
    if (!profile.userName?.trim()) {
      newErrors.userName = "Full Name is required";
    }

    if (!profile.newEmail?.trim()) {
      newErrors.newEmail = "Email is required";
    } else if (!/^\S+@\S+\.\S+$/.test(profile.newEmail)) {
      newErrors.newEmail = "Invalid email format";
    }

    if (!profile.phoneNumber?.trim()) {
      newErrors.phone = "Phone number is required";
    } else if (phoneError) {
      newErrors.phone = phoneError;
    }

    if (!profile.emailContact && !profile.phoneContact) {
      newErrors.contactPreference =
        "Please select contact preference";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  return (
    <>
      <Box
        sx={{
          width: "80%",
          margin: "30px auto",
          padding: 4,
          border: "1px solid #ddd",
          borderRadius: 2,
          background: "#fff",
          // height: "60vh",
        }}
      >
        <Typography variant="h5" sx={{ mb: 3, fontWeight: 600 }}>
          User Profile
        </Typography>

        {/* <Grid container spacing={3}>

        {/* Non-editable 
        <Grid item xs={6}>
          <TextField
            fullWidth
            label="User Name"
            name="userName"
            value={profile.userName}
            disabled
          />
        </Grid>

        {/* Non-editable 
        <Grid item xs={6}>
          <TextField
            fullWidth
            label="Role"
            name="userRole"
            value={profile.userRole}
            disabled
          />
        </Grid>

        {/* Editable 
        <Grid item xs={6}>
          <TextField
            fullWidth
            label="Email"
            name="emailId"
            value={profile.emailId}
            onChange={handleChange}
          />
        </Grid>

        {/* Editable 
        <Grid item xs={6}>
          <TextField
            fullWidth
            label="Phone Number"
            name="phoneNumber"
            value={profile.phoneNumber}
            onChange={handleChange}
          />
        </Grid>

        {/* Non-editable 
        <Grid item xs={6}>
          <TextField
            fullWidth
            label="Organisation"
            name="organisation"
            value={profile.organisation}
            disabled
          />
        </Grid>

        {/* Non-editable 
        <Grid item xs={6}>
          <TextField
            fullWidth
            label="Job Title"
            name="jobTitle"
            value={profile.jobTitle}
            disabled
          />
        </Grid>

        {/* Non-editable 
        <Grid item xs={6}>
          <TextField
            fullWidth
            label="Domain"
            name="userDomain"
            value={profile.userDomain}
            disabled
          />
        </Grid>

        {/* Non-editable 
        <Grid item xs={6}>
          <TextField
            fullWidth
            label="Category"
            name="userCategory"
            value={profile.userCategory}
            disabled
          />
        </Grid>

        {/* Non-editable 
        <Grid item xs={12}>
          <TextField
            fullWidth
            multiline
            rows={3}
            label="Remarks"
            name="remarks"
            value={profile.remarks}
            disabled
          />
        </Grid>

      </Grid> */}

        <Box sx={{ mb: 2 }}>
          <Typography
            sx={{
              mb: 0.5,
              fontFamily: "Akkurat-Pro",
              fontSize: {
                xs: "0.8rem",
                sm: "0.8rem",
                md: "0.8rem",
                lg: "0.75rem",
                xl: "0.9rem",
              },
              color: "#525252",
            }}
          >
            Full Name*
          </Typography>

          <TextField
            name="userName"
            value={profile.userName}
            onChange={handleChange}
            placeholder="John Doe"
            variant="standard"
            slotProps={{ input: { disableUnderline: true } }}
            sx={{
              borderRadius: "1.75rem",
              border: "1px solid #E0E0E0",
              px: 2,
              py: 0.5,
              width: "90%",
              height: "25px",
              "& .MuiInputBase-input": {
                fontSize: "0.82rem",
              },

              "& input:-webkit-autofill": {
                WebkitBoxShadow: "0 0 0 1000px #FFFFFF inset",
                WebkitTextFillColor: "#000",
                caretColor: "#000",
                transition: "background-color 9999s ease-out 0s",
              },
              "& .MuiTypography-root": {
                fontFamily: "Akkurat",
              },
            }}
          />

          {errors.userName && (
            <Typography sx={{ color: "red", fontSize: "0.75rem" }}>
              {errors.userName}
            </Typography>
          )}
        </Box>

        {/* EMAIL */}
         <Box sx={{ mb: 2 }}>
          <Typography
            sx={{
              mb: 0.5,
              fontSize: {
                xs: "0.8rem",
                sm: "0.8rem",
                md: "0.8rem",
                lg: "0.75rem",
                xl: "0.9rem",
              },
              color: "#525252",
            }}
          >
            Current Email*
          </Typography>

          <TextField
            name="currentEmail"
            value={profile.currentEmail}
            onChange={handleChange}
            placeholder="i.e. john.doe@sandhata.com"
            variant="standard"
            slotProps={{ input: { disableUnderline: true } }}
            disabled={true}
            sx={{
              borderRadius: "1.75rem",
              border: "1px solid #E0E0E0",
              px: 2,
              py: 0.5,
              width: "90%",
              height: "25px",
              "& .MuiInputBase-input": {
                fontSize: "0.82rem",
              },
              "& .MuiTypography-root": {
                fontFamily: "Montserrat",
              },
              "& input:-webkit-autofill": {
                WebkitBoxShadow: "0 0 0 1000px #FFFFFF inset",
                WebkitTextFillColor: "#000",
                caretColor: "#000",
                transition: "background-color 9999s ease-out 0s",
              },
            }}
          />

          {errors.currentEmail && (
            <Typography
              sx={{
                color: "red",
                fontSize: {
                  xs: "0.8rem",
                  sm: "0.8rem",
                  md: "0.8rem",
                  lg: "0.8rem",
                  xl: "0.9rem",
                },
              }}
            >
              {errors.currentEmail}
            </Typography>
          )}
        </Box> 
        {/* NEW MAIL */}
        <Box sx={{ mb: 2 }}>
          <Typography
            sx={{
              mb: 0.5,
              fontFamily: "Akkurat-Pro",
              fontSize: {
                xs: "0.8rem",
                sm: "0.8rem",
                md: "0.8rem",
                lg: "0.75rem",
                xl: "0.9rem",
              },
              color: "#525252",
            }}
          >
            Email id *
          </Typography>

          <TextField
            name="newEmail"
            value={profile.newEmail}
            onChange={handleChange}
            variant="standard"
            slotProps={{ input: { disableUnderline: true } }}
            sx={{
              borderRadius: "1.75rem",
              border: "1px solid #E0E0E0",
              px: 2,
              py: 0.5,
              width: "90%",
              height: "25px",
              "& .MuiInputBase-input": {
                fontSize: "0.82rem",
              },

              "& input:-webkit-autofill": {
                WebkitBoxShadow: "0 0 0 1000px #FFFFFF inset",
                WebkitTextFillColor: "#000",
                caretColor: "#000",
                transition: "background-color 9999s ease-out 0s",
              },
              "& .MuiTypography-root": {
                fontFamily: "Akkurat",
              },
            }}
          />
          {errors.newEmail && (
            <Typography sx={{ color: "red", fontSize: "0.75rem" }}>
              {errors.newEmail}
            </Typography>
          )}
        </Box>
        {/*  PHONE NUMBER  */}
        <Box sx={{ mb: 2 }}>
          <Typography sx={labelSx}>Phone Number*</Typography>
          <PhoneInput
            country="us"
            value={profile.phoneNumber}
            onChange={handlePhoneChange}
            enableSearch={true}
            countryCodeEditable={false}
            inputStyle={{
              width: "94%",
              borderRadius: "18px",
              fontSize: "15px",
            }}
            buttonStyle={{
              borderRadius: "18px 0 0 18px",
              borderRight: "none",
            }}
            containerStyle={{ width: "100%" }}
          />
          {errors.phone && (
            <Typography sx={errorSx}>{errors.phone}</Typography>
          )}

          
        </Box>
        {/* PHONE NUMBER */}

        {/* CONTACT PREFERENCE */}
        <Box sx={{ mb: 3 }}>
          <Typography sx={labelSx}>
            Contact Preference*
          </Typography>

          <FormGroup row>
            <FormControlLabel
              control={
                <Checkbox
                  checked={profile.emailContact}
                  onChange={handleCheckBoxChange}
                  name="emailContact"
                />
              }
              label="Email"
            />

            <FormControlLabel
              control={
                <Checkbox
                  checked={profile.phoneContact}
                  onChange={handleCheckBoxChange}
                  name="phoneContact"
                />
              }
              label="Phone"
            />
          </FormGroup>

          {errors.contactPreference && (
            <Typography sx={errorSx}>
              {errors.contactPreference}
            </Typography>
          )}
        </Box>

        {/* BUTTONS */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            mt: 4,
            gap: 2,
          }}
        >
          <Button variant="outlined" onClick={handleCancel}>
            Cancel
          </Button>

          <Button variant="contained" onClick={handleSubmit}>
            Save
          </Button>
        </Box>
      </Box>
      <SuccessBanner open={successOpen} message={successMessage} />
    </>
  );
}
